module.exports = __webpack_public_path__ + "img/bras_8kl.b38c96b6.jpg";